module.exports = __webpack_public_path__ + "static/media/logo_signature.49dce7f0.png";